module.exports = __webpack_public_path__ + "static/media/3.d23492a9.jpg";